export const Brand = "CardioHut";